import React, {useEffect, useRef, useState} from 'react';
import {Button, Grid, TextField,} from "@mui/material";
import Select from "react-select";
import axios from 'axios';
import LocationSelect from "./components/LocationSelect";
import PasswordField from "./components/PasswordField";
import {LocationOn} from "@mui/icons-material";
import Header from "./components/Header";
import InputMask from 'react-input-mask';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {API_URL} from "./config";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Footer from "./components/Footer";
const libraries = ['places'];
const mapContainerStyle = {
    height: '400px',
    width: '100%'
};

const center = {
    lat: 34.052235,
    lng: -118.243683
};

const options = {
    disableDefaultUI: true,
    zoomControl: true,
};
// Leaflet'in varsayılan ikonlarını düzeltme
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Haritayı yeni konuma taşıyan bileşen
const FlyToLocation = ({ position }) => {
    const map = useMap();
    useEffect(() => {
        if (position) {
            map.flyTo(position, 13, {
                duration: 1.5, // Haritanın hareket süresi (saniye)
            });
        }
    }, [position, map]);

    return null;
};

export default function ProfileSettings() {
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);
    const searchBoxRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState();
    const [selectedOlanak,setSelectedOlanak]=useState();
    const [selectedBrans,setSelectedBrans]=useState();
    const [address, setAddress] = useState();
    const [isimSoyisim, setIsimSoyisim] = useState();
    const [telefon, setTelefon] = useState();
    const [email, setEmail] = useState();
    const [sifre, setSifre] = useState();
    const [city, setCity] = useState();
    const [district, setDistrict] = useState();
    const [hospital, setHospital] = useState();
    const [passwordErrorParent, setPasswordErrorParent] = useState(false);
    const [passwordParent, setPasswordParent] = useState('');
    const [kayitTipi, setKayitTipi] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [description, setDescription] = useState('');
    const [file,setFile]=useState();
    const [profilePhoto,setProfilePhoto]=useState();
    const [editInformation, setEditInformation] = useState(false);
   const [editDate, setEditDate] = useState(false);
    const [isimSoyisimError, setIsimSoyisimError] = useState(false);
    const [telefonError, setTelefonError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [districtError, setDistrictError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [selectedBransError, setSelectedBransError] = useState(false);
    const [userLocation, setUserLocation] = useState(null); // Kullanıcının mevcut konumu
    const [markerPosition, setMarkerPosition] = useState(null); // Marker'ın bulunduğu konum
    const [searchQuery, setSearchQuery] = useState(""); // Arama kutusundaki metin
    const [suggestions, setSuggestions] = useState([]); // Adres önerileri
    const [error,setError]= useState('');


    // Kullanıcı konumunu alma
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const currentLocation = [position.coords.latitude, position.coords.longitude];
                    setUserLocation(currentLocation);
                    setMarkerPosition(currentLocation);
                },
                (error) => {
                    console.error("Konum alınamadı:", error);
                    const defaultLocation = [51.505, -0.09];
                    setUserLocation(defaultLocation);
                    setMarkerPosition(defaultLocation);
                }
            );
        } else {
            console.error("Tarayıcı konum servisini desteklemiyor.");
            const defaultLocation = [51.505, -0.09];
            setUserLocation(defaultLocation);
            setMarkerPosition(defaultLocation);
        }
        getDoctorInformations()
    }, [map]);
        const getDoctorInformations = (latitude, longitude) => {
            let doctor_id= localStorage.getItem('ac_id');
            let token = JSON.parse(localStorage.getItem("ac_auth_token"));

            console.log('doctor_id',doctor_id)
        axios.get(`${API_URL}/doctors/${doctor_id}`, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {

            console.log('veriler',response.data);
            const data = response.data;
            setAddress(data.address || '');
            setIsimSoyisim(data.name || '');
            setTelefon(data.phone || '');
            setCity(data.city || '');
            setSelectedBrans({"value": data.department, "label": data.department});
            setDistrict(data.district || '');
            setHospital(data.hospital || '');
            setWhatsapp(data.whatsapp || '');
            setDescription(data.description || '');
            setMarker(data.coordinates ? { lat: data.coordinates.lat, lng: data.coordinates.lng } : null);
            const currentLocation = [data.coordinates.lat, data.coordinates.lng];
            setUserLocation(currentLocation);
            setMarkerPosition(currentLocation);
            setEmail(data.email)
            setSelectedOption(data.insurance ? data.insurance.selectedOption : '')
            setKayitTipi(data.doctor_or_hospital)
            setHospital(data.hospital || '')
            setSelectedOlanak(data.services ? data.services.selectedOlanak : '')
            setProfilePhoto(data.profile_photo ? 'data:image/JPEG;base64,'+data.profile_photo : '')
            console.log('coordinates',data.coordinates)
         })
        .catch((error) => {
            console.error('Error:', error);
        });
    };
    // Adres tamamlama için Photon API
    const handleSearchChange = async (e) => {
        const query = e.target.value ; // Trim ile baştaki ve sondaki boşlukları temizle
        setSearchQuery(query);

        if (query.length > 2) {
            try {
                setError(null);
                const response = await fetch(
                    `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&lang=default`
                );
                const data = await response.json();

                if (data && data.features && data.features.length > 0) {
                    setSuggestions(
                        data.features.map((feat) => ({
                            name: feat.properties.name,
                            city: feat.properties.city || "",
                            country: feat.properties.country || "",
                            lat: feat.geometry.coordinates[1],
                            lon: feat.geometry.coordinates[0],
                        }))
                    );
                } else {
                    setSuggestions([]);
                }
            } catch (err) {
                setError("Adres önerileri alınamadı. Lütfen tekrar deneyin.");
                console.error(err);
            }
        } else {
            setSuggestions([]);
        }
    };

    // Öneri seçimi
    const handleSuggestionClick = (suggestion) => {
        const newPosition = [suggestion.lat, suggestion.lon];
        setMarkerPosition(newPosition);
        setUserLocation(newPosition); // Haritayı yeni marker konumuna taşı
        setSearchQuery(""); // Arama kutusunu temizle
        setSuggestions([]); // Önerileri temizle
    };

    const branslar = [
        { "value": "Çocuk Acil", "label": "Çocuk Acil" },
        { "value": "Genel Çocuk polikliniği", "label": "Genel Çocuk polikliniği" },
        { "value": "Çocuk Endokrinoloji", "label": "Çocuk Endokrinoloji" },
        { "value": "Çocuk Enfeksiyon Hastalıkları", "label": "Çocuk Enfeksiyon Hastalıkları" },
        { "value": "Çocuk Gastroenteroloji", "label": "Çocuk Gastroenteroloji" },
        { "value": "Çocuk Genetic Hastalıkları", "label": "Çocuk Genetic Hastalıkları" },
        { "value": "Çocuk Göğüs Hastalıkları", "label": "Çocuk Göğüs Hastalıkları" },
        { "value": "Çocuk Hematoloji ve Onkoloji", "label": "Çocuk Hematoloji ve Onkoloji" },
        { "value": "Çocuk İmmunoloji", "label": "Çocuk İmmunoloji" },
        { "value": "Çocuk Allerji", "label": "Çocuk Allerji" },
        { "value": "Çocuk Kardiyoloji", "label": "Çocuk Kardiyoloji" },
        { "value": "Çocuk Beslenme ve Metabolizma", "label": "Çocuk Beslenme ve Metabolizma" },
        { "value": "Çocuk Nöroloji", "label": "Çocuk Nöroloji" },
        { "value": "Çocuk Romatoloji", "label": "Çocuk Romatoloji" },
        { "value": "Çocuk Nefroloji", "label": "Çocuk Nefroloji" },
        { "value": "Çocuk Yoğun Bakım", "label": "Çocuk Yoğun Bakım" },
        { "value": "Gelişimsel Pediatri", "label": "Gelişimsel Pediatri" },
        { "value": "Neonatoloji (Yenidoğan)", "label": "Neonatoloji (Yenidoğan)" },
        { "value": "Yenidoğan Yoğun Bakım", "label": "Yenidoğan Yoğun Bakım" },
        { "value": "Çocuk Nefroloji", "label": "Çocuk Nefroloji" },
        { "value": "Çocuk and Ergen Psikiyatrisi", "label": "Çocuk and Ergen Psikiyatrisi" },
        { "value": "Çocuk Üroloji", "label": "Çocuk Üroloji" },
        { "value": "Çocuk Cerrahisi", "label": "Çocuk Cerrahisi" }
    ];
    const customStyles = (hasError) => ({
        control: (provided, state) => ({
            ...provided,
            border: hasError ? '1px solid red' : state.isFocused ? '1px solid blue' : '1px solid gray',
            '&:hover': {
                border: hasError ? '1px solid red' : '1px solid blue',
            },
        }),

    });
    const onFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            setFile(reader.result);
        };

        reader.readAsDataURL(file);
    };

const  editMode= () => {
 return (
     <>
     <h2>{kayitTipi == 'doctor' ? 'Doktor' : 'Hastane'} Kaydı</h2>
    <Grid container spacing={3} maxWidth={'95%'} style={{padding: 20}}>
        <Grid item xs={12} sm={12}>
            <span>Kayıt Tipi</span>
            <p></p>
            <label>Doktor </label>
            <input type={'checkbox'} value={kayitTipi} name={'kayit-tipi'} onClick={() => {

                setKayitTipi('doctor')

            }} checked={kayitTipi == 'doctor' ? true : false}/>
            <label>Hastane</label>
            <input type={'checkbox'} value={kayitTipi} name={'kayit-tipi'}
                   onClick={() => {

                       setKayitTipi('hospital')

                   }}

                   checked={kayitTipi == 'hospital' ? true : false}/>

        </Grid>

        <Grid item xs={12} sm={12} >
            <label>Profil Fotoğrafı</label>
            <p></p>
            <img src={file ? file : profilePhoto} width={'280px'} />
            <p></p>
            <input type={'file'} name={'profile-photo'} id={'profile-photo'} onChange={onFileChange}
            />
        </Grid>
        <p></p>
        <Grid item xs={12} sm={6}>
            <label>{kayitTipi == 'doctor' ? 'İsim Soyisim' : 'Hastane Adı'} </label>
            <TextField size={'small'} name={'isim-soyisim'}
                       placeholder={kayitTipi == 'doctor' ? 'İsim Soyisim' : 'Hastane Adı'} fullWidth={true}
                       value={isimSoyisim} variant="outlined" onChange={handleChange}
                       style={{ border: isimSoyisimError ? '1px solid red' : '1px solid #ccc' }}
            />
        </Grid>

        <Grid item xs={12} sm={6}>
            <label>Telefon</label>
            <InputMask
                mask="0999 999 99 99"
                value={telefon}
                onChange={handleChange}
                placeholder="0XXX 123 45 67"
                maskChar={null}
            >
                {(inputProps) => <TextField size={'small'} name={'telefon'} placeholder={'Telefon'} fullWidth={true}
                                            variant="outlined"  {...inputProps}
                                            style={{ border: telefonError ? '1px solid red' : '1px solid #ccc' }}
                />}
            </InputMask>
        </Grid>

        <Grid item xs={12} sm={6}>
            <label>Eposta Adresi</label>
            <TextField size={'small'} name={'email'} placeholder={'Email'} fullWidth={true}
                       variant="outlined" onChange={handleChange} value={email}
                       style={{ border: telefonError ? '1px solid red' : '1px solid #ccc' }}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <label>WhatsApp Numarası</label>

            <InputMask
                mask="0999 999 99 99"
                value={whatsapp}
                onChange={handleChange}
                placeholder="0XXX 123 45 67"
                maskChar={null}
            >
                {(inputProps) => <TextField size={'small'} name={'whatsapp'} placeholder={'WhatsApp'} fullWidth={true}
                                            variant="outlined"  {...inputProps} />}
            </InputMask>

        </Grid>


        <Grid item xs={12} sm={kayitTipi=='hospital' ? 12 : 6}>
            <label>Adres</label>
            <TextField size={'small'} name={'adres'} placeholder={'Adres'} multiline={true} rows={2}
                       fullWidth={true} variant="outlined" onChange={handleChange} value={address}
                       style={{ border: addressError ? '1px solid red' : '1px solid #ccc' }}
            />
        </Grid>
        <Grid item xs={12} sm={6} style={kayitTipi=='hospital' ? {display:'none'} : {}} >
            <label>Branş</label>
            <Select options={branslar} value={selectedBrans} isMulti={false}
                    onChange={setSelectedBrans}
                    styles={customStyles(selectedBransError)}
            > </Select>
        </Grid>
        <LocationSelect setCity={setCity} setDistrict={setDistrict} selectedCity={city} selectedDistrict={district} cityError={cityError} districtError={districtError} />

        <Grid item xs={12} sm={6}>
            <label style={kayitTipi == 'hospital' ? {display: 'none'} : {}}>Hastane</label>
            <TextField style={kayitTipi == 'hospital' ? {display: 'none'} : {}} size={'small'} name={'hospital'}
                       placeholder={'Hastane'} fullWidth={true}
                       variant="outlined" onChange={handleChange} value={hospital}/>
        </Grid>

        <Grid item xs={12} sm={6}>


        </Grid>


        <Grid item xs={12} sm={6}>
            <label>Varsa Anlaşmalı Sağlık Kurumu</label>
            <Select options={sigortaSirketleri} value={selectedOption} isMulti={true}
                    onChange={setSelectedOption}> </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
            <label>Sunulan Hizmetler</label>
            <Select options={olanaklar} value={selectedOlanak} isMulti={true}
                    onChange={setSelectedOlanak}> </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
            <label>Notlar</label>
            <TextField size={'small'} name={'description'} placeholder={'Notlar'} multiline={true} rows={2} value={description}
                       fullWidth={true} variant="outlined" onChange={handleChange}/>
        </Grid>
        <Grid item xs={12}>
            <span>Daha net bir konum için haritadaki kırmızı pin (</span><LocationOn
            style={{color: 'blue'}}></LocationOn><span>) ikonunu hareket ettirerek konumunuzu haritadan işaretleyiniz</span>
            <div style={{position: "relative"}}>
                <h1>Konum Seçici</h1>

                {/* Arama Kutusu */}
                <div style={{marginBottom: "10px"}}>
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Bir adres girin (ör: Etiler, İstanbul)"
                        style={{width: "300px", padding: "5px"}}
                    />
                    {error && <p style={{color: "red"}}>{error}</p>}
                </div>

                {/* Harita */}
                {userLocation ? (
                    <div style={{position: "relative", height: "500px"}}>
                        {/* Öneri Listesi */}
                        {suggestions.length > 0 && (
                            <ul
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "10px",
                                    background: "white",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    zIndex: 1000,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "300px",
                                }}
                            >
                                {suggestions.map((sug, index) => (
                                    <li
                                        key={index}
                                        onClick={() => handleSuggestionClick(sug)}
                                        style={{
                                            padding: "5px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        {sug.name}, {sug.city}, {sug.country}
                                    </li>
                                ))}
                            </ul>
                        )}

                        <MapContainer
                            center={userLocation}
                            zoom={13}
                            style={{height: "100%", width: "100%"}}
                        >
                            <FlyToLocation position={userLocation}/>
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution="&copy; OpenStreetMap contributors"
                            />
                            {markerPosition && (
                                <Marker
                                    position={markerPosition}
                                    draggable={true}
                                    eventHandlers={{
                                        dragend: (e) => {
                                            const newPosition = [
                                                e.target.getLatLng().lat,
                                                e.target.getLatLng().lng,
                                            ];
                                            console.log(newPosition);
                                            setMarkerPosition(newPosition);
                                        },
                                    }}
                                >
                                    <Popup>
                                        Marker konumu: <br/>
                                        Enlem: {markerPosition[0].toFixed(4)} <br/>
                                        Boylam: {markerPosition[1].toFixed(4)}
                                    </Popup>
                                </Marker>
                            )}
                        </MapContainer>
                    </div>
                ) : (
                    <p>Konumunuz alınıyor...</p>
                )}
                    </div>

        </Grid>

        <Grid item xs={12} style={{marginTop: '20', display: 'flex', justifyContent: 'flex-end'}}>
            <Button disabled={passwordErrorParent} variant="contained" color={'success'}
                    style={{boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)'}} onClick={() => {
                handleSubmit()
            }}> Kaydet</Button>
        </Grid>
    </Grid></>
)
}
const  editDateMode= () => {
    return (
        <div></div>
    )
}

     const handleChange = (event) => {

        const {name, value} = event.target;
        console.warn(name, value)
        switch (name) {
            case 'isim-soyisim':
                setIsimSoyisim(value);
                break;
            case 'telefon':
                const phonePattern = /^0[5-7]\d{2} \d{3} \d{2} \d{2}$/;
                 if (phonePattern.test(value)) {
                   setError('');
                  } else {
                   setError('Geçersiz telefon numarası formatı. Lütfen 0532 283 87 80 formatında giriniz.');
                  }
                setTelefon(value);
                break;
            case 'email':
                setEmail(value);
                break;
            case 'sifre':
                setSifre(value);
                break;
            case 'adres':
                setAddress(value);
                break;
            case 'hospital':
                setHospital(value);
                break;
            case 'whatsapp':
                setWhatsapp(value);
                break;
            case 'description':
                setDescription(value);
                break;
            default:
                break;
        }


     }

     const handleSubmit = () => {
         let doctor_id= localStorage.getItem('id');
         let token = JSON.parse(localStorage.getItem("ac_auth_token"));
         console.log(selectedOption);
         let hasError = false;
         if (!isimSoyisim && kayitTipi=='doctor') {
             setIsimSoyisimError(true);
             toast.error("İsim Soyisim alanı zorunludur!");
             hasError = true;
         } else {
             setIsimSoyisimError(false);
         }

         if (!isimSoyisim && kayitTipi=='hospital') {
             setIsimSoyisimError(true);
             toast.error("Hastane adı alanı zorunludur!");
             hasError = true;
         } else {
             setIsimSoyisimError(false);
         }

         if (!telefon) {
             setTelefonError(true);
             toast.error("Telefon numarası zorunludur!");
             hasError = true;
         } else {
             setTelefonError(false);
         }

         if (!email) {
             setEmailError(true);
             toast.error("E-posta adresi zorunludur!");
             hasError = true;
         } else {
             setEmailError(false);
         }

         if (!city) {
             setCityError(true);
             toast.error("Şehir seçimi zorunludur!");
             hasError = true;
         } else {
             setCityError(false);
         }

         if (!district) {
             setDistrictError(true);
             toast.error("İlçe seçimi zorunludur!");
             hasError = true;
         } else {
             setDistrictError(false);
         }

         if (!address) {
             setAddressError(true);
             toast.error("Adres bilgisi zorunludur!");
             hasError = true;
         } else {
             setAddressError(false);
         }

         if (!selectedBrans && kayitTipi=='doctor') {
             setSelectedBransError(true);
             toast.error("Branş seçimi zorunludur!");
             hasError = true;
         } else {
             setSelectedBransError(false);
         }

         if (hasError) {
             return; // Eğer bir hata varsa işlemi durdur
         }
         axios.post(`${API_URL}/update-doctor`, {
                id: doctor_id,
                name: isimSoyisim,
                phone: telefon,
                 city: city,
                 district: district,
                 hospital: hospital,
                  department: selectedBrans ? selectedBrans.label : null,
                 insurance:  selectedOption ? {selectedOption} : null,
                 address: address,
                 coordinates: {"lat": markerPosition[0], "lng": markerPosition[1]} ,
                 email: email,
                 password: passwordParent,
                 whatsapp: whatsapp,
                 description: description,
                 doctor_or_hospital: kayitTipi,
                 profile_photo:file,
                 services:  selectedOlanak ? {selectedOlanak} : null,
         },{
             headers: {
                 Accept: "application/json",
                 Authorization: `Bearer ${token}`,
             },
         })
                .then(function (response) {

                    toast.success("Güncelleme Başarılı");

                    if(response.data.status=='success'){
                        toast.success("Kayıt Başarılı");                }
                    else{
                        toast.error(response.data.message);
                    }

                })
                .catch(function (error) {
                    console.log(error);
                     toast.error("Kayıt Başarısız");

                });
         }



    const onMapLoad = (mapInstance) => {
        setMap(mapInstance);
        if (marker) {
            mapInstance.panTo(marker); // Harita yüklenirken marker varsa, panTo kullan
        }
    };




    const onMarkerDragEnd = (e) => {
        const newPos = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
        };
        setMarker(newPos);
        console.log('yeni Konum bulundu:', newPos);

        if (map) {
            map.panTo(newPos); // Harita yüklendiyse, panTo kullan
        }
    };

    const onPlacesChanged = () => {
        const places = searchBoxRef.current.getPlaces();
        if (places && places.length > 0) {
            const place = places[0];
            if (place.geometry) {
                const newPos = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
                setMarker(newPos);

                if (map) {
                    map.panTo(newPos); // Harita yüklendiyse, panTo kullan
                }
            }
        }
    };
    const sigortaSirketleri = [
        {"value": "Allianz", "label": "Allianz"},
        {"value": "Acıbadem Sigorta", "label": "Acıbadem Sigorta"},
        {"value": "Aksigorta", "label": "Aksigorta"},
        {"value": "Anadolu Sigorta", "label": "Anadolu Sigorta"},
        {"value": "AXA Sigorta", "label": "AXA Sigorta"},
        {"value": "Demir Sağlık ve Hayat", "label": "Demir Sağlık ve Hayat"},
        {"value": "Güneş Sigorta", "label": "Güneş Sigorta"},
        {"value": "Mapfre Sigorta", "label": "Mapfre Sigorta"},
                {"value": "SGK", "label": "SGK"},

        {"value": "Sompo Sigorta", "label": "Sompo Sigorta"},
        {"value": "Türkiye Sigorta", "label": "Türkiye Sigorta"}
    ]
    const olanaklar = [

        {"value": "Serum", "label": "Serum"},
        {"value": "Tahliller", "label": "Tahliller"},
        {"value": "Ultrasonografi", "label": "Ultrasonografi"},
        {"value": "Röntgen", "label": "Röntgen"},
        {"value": "Bilgisayarlı Tomografi", "label": "Bilgisayarlı Tomografi"},
        {"value": "MRI", "label": "MRI"},
        {"value": "Anestezi MRI", "label": "Anestezi MRI"},
        {"value": "Yenidoğan Yoğun Bakım", "label": "Yenidoğan Yoğun Bakım"},
        {"value": "2. Düzey Yenidoğan Yoğun Bakım", "label": "2. Düzey Yenidoğan Yoğun Bakım"},
        {"value": "3. Düzey Yenidoğan Yoğun Bakım", "label": "3. Düzey Yenidoğan Yoğun Bakım"}
    ]



    return (

        <React.Fragment>

          <Header/>


            { editMode() }

        <Footer />
        </React.Fragment>
);
}




